module.exports = __webpack_public_path__ + "img/SHhouTai.6d41d053.png";